import React, { useEffect, useState } from 'react';
import { useAuth } from '../../contexts/auth.context';
import {
    CHECKOUT_CARD_ROUTE,
    CHECKOUT_ROUTE,
    FORGOT_PASSWORD_ROUTE,
    HOME_ROUTE,
    REGISTRATION_ROUTE
} from '../../router/constants';
import mailcheck from 'mailcheck';
import classNames from 'classnames';
import { Portal } from '../../components/Portal';
import { Link, useHistory } from 'react-router-dom';

const validateEmail = (email) => {
    const zone = email.split('.').pop();
    // if (!['com', 'org', 'edu'].includes(zone.toLowerCase())) { return false; }
    return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email);
};

const initialData = {
    email: '',
    password: '',
};

const initValidFields = {
    email: false,
    password: false,
};

const AuthModal = ({ isOpen, onClose }) => {
    const [data, setData] = useState(initialData);
    const [validated, setValidated] = useState(initValidFields);
    const [isLoading, setIsLoading] = useState(false);

    const [suggestedEmail, setSuggestedEmail] = useState(null);
    
    const { login, error, user } = useAuth();
    
    const history = useHistory();

    const handlerChange = (e) => {
        const {name, value} = e.target;

        setData(prevData => {
            return {
                ...prevData,
                [name]: value
            }
        });
    };

    const handleLoginSubmit = async (e) => {
        e.preventDefault();

        const isValid = validated.email && validated.password;

        if (!isValid) {
            return;
        }

        try {
            setIsLoading(true);
            await login(data);

            const isNeedRedirect = window.location.pathname.startsWith(CHECKOUT_CARD_ROUTE)
            if (isNeedRedirect) {
                window.location.replace(CHECKOUT_ROUTE);
            }
        }
        finally {
            setIsLoading(false);
        }
    };
    
    const handleSuggestionEmail = (e) => {
        e.preventDefault();
        setData(prevState => ({...prevState, email: suggestedEmail.full}));
    };

    useEffect(() => {
        if (!user) return;

        onClose?.();
    }, [user]);

    useEffect(() => {
        setValidated((prevState) => {
            return {
                email: validateEmail(data.email),
                password: data.password.length >= 4,
            }
        });
    }, [data]);

    useEffect(() => {
        mailcheck.run({
            email: data.email,
            // domains: domains,                       // optional
            // topLevelDomains: topLevelDomains,       // optional
            // secondLevelDomains: secondLevelDomains, // optional
            // distanceFunction: superStringDistance,  // optional
            suggested: (suggestion) => {
                setSuggestedEmail(suggestion);
            },
            empty: (element) => {
                // callback code
            }
        });
    }, [data.email]);
    
    if (!isOpen) {
        return null;
    }
    
    return (
        <Portal>
            <div className="modal fade show" tabIndex="-1" role="dialog">
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Login</h5>
                            <button type="button" className="close text-muted" aria-label="Close" onClick={onClose}>
                                Close&nbsp;
                                <span aria-hidden="true">
                                    <i className="fas fa-times" style={{fontSize: '25px'}}></i>
                                </span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <form className="d-flex flex-column mt-4" style={{gap: '1rem'}}>

                                {!!error && (
                                    <div
                                        className="alert alert-danger"
                                    >
                                        {error}
                                    </div>
                                )}

                                <div>
                                    <label>Email<span className="text-danger">* Required</span></label>
                                    <div className="form-group">
                                        <input type="text"
                                               className="form-control"
                                               name="email"
                                               placeholder="E-mail"
                                               onChange={handlerChange}
                                               value={data.email}
                                               autoFocus
                                        />

                                        {suggestedEmail && data.email !== suggestedEmail.full && (
                                            <small className="form-text text-left d-block" style={{width: '100%'}}>
                                                <span className="font-weight-bold">Did you mean</span> <a href="#" onClick={handleSuggestionEmail}>{suggestedEmail.address}@<span className="font-weight-bold">{suggestedEmail.domain}</span></a>?
                                            </small>
                                        )}

                                        {/*<div className={classNames('invalid-feedback', {'d-block': !validated.email})}>*/}
                                        {/*    Please input a valid email.*/}
                                        {/*</div>*/}
                                    </div>

                                    <label>Password<span className="text-danger">* Required</span></label>
                                    <div className="form-group">
                                        <input type="text"
                                               className="form-control"
                                               name="password"
                                               placeholder="Password"
                                               onChange={handlerChange}
                                               value={data.password} />

                                        {/*<div className={classNames('invalid-feedback', {'d-block': !validated.password})}>*/}
                                        {/*    Please input a valid password at least 4 characters length.*/}
                                        {/*</div>*/}
                                    </div>
                                </div>

                            </form>
                        </div>
                        
                        <div className="modal-footer justify-content-between">
                            <div className="d-flex flex-column">
                                <Link
                                    to={FORGOT_PASSWORD_ROUTE}
                                    className="btn btn-dlg-secondary text-left p-0"
                                >
                                    Forgot Password?
                                </Link>
                                <Link
                                    to={REGISTRATION_ROUTE}
                                    className="btn btn-dlg-secondary text-left p-0"
                                >
                                    Sign Up
                                </Link>
                            </div>
                            
                            <div className="d-flex">
                                <button
                                    type="button"
                                    className="btn btn-dlg-primary pl-4 pr-4"
                                    onClick={handleLoginSubmit}
                                    disabled={isLoading}
                                >
                                    Login
                                </button>

                                <button
                                    type="button"
                                    className="btn btn-dlg-secondary pl-4 pr-4"
                                    onClick={onClose}
                                    disabled={isLoading}
                                >
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Portal>
    );
};

export default AuthModal;
